







import Vue from "vue"
import CProjectDetailPublicPage from "~/components/custom/projectDetail/CProjectDetailPublicPage.vue"
import { ProjectView } from "~/backendApis/viewModel"

interface DataType {
  project: ProjectView | null
}

export default Vue.extend({
  components: {
    CProjectDetailPublicPage,
  },
  layout: "application",
  validate({ params }) {
    return params.id !== undefined && /^[a-zA-Z0-9]+$/.test(params.id)
  },
  data(): DataType {
    return {
      project: null,
    }
  },
  async fetch() {
    this.project = await this.$clStores.projectSearchList.getters.getProjectByIdFromListOrRemote(
      this.$route.params.id
    )
  },
  head(): object {
    const appEnv = process.env.APP_ENV
    const backendFileAPIBaseURL = process.env.BACKEND_FILE_API_BASE_URL
    return this.$clHelpers.metaTag.generate({
      title: this.project?.title || undefined,
      currentPath: this.$nuxt.$route.path,
      ogpImageUrl:
        appEnv === "production" // OGPは本番環境でのみ表示。ステージングはファイルAPI側がIP制限の関係でOGPの生成に対応していないため。
          ? `${backendFileAPIBaseURL}/project_ogp/${this.$route.params.id}`
          : undefined,
    })
  },
  watch: {
    "$fetchState.error"() {
      this.$nuxt.error({ statusCode: 404 })
    },
  },
  created() {
    this.$clStores.mobileNavigationMenu.actions.changeState({
      previousPagePath: "/projects",
      pageTitle: "プロジェクト",
    })
  },
  async mounted() {
    await this.$clStores.swCorporationAccount.actions.loadList()
  },
})
